import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import TopNav from "@/components/TopNav";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await resetPassword(email.trim());
      setSent(true);
      toast.success("Recovery email sent. Check your inbox.");
    } catch (err) {
      toast.error(err?.message || "Failed to send recovery email");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <TopNav />
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="fx-mono-tag mb-4">§ RECOVERY</div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight">Reset your password.</h1>
          <p className="mt-5 text-[#475569] max-w-sm">Enter the email you used for Agenaix and we'll send a recovery link.</p>
          <div className="mt-8 border-t border-[#DCE3ED] pt-5 fx-mono-tag">
            REMEMBERED?{" "}
            <Link to="/login" className="text-[#0B4DCC] hover:underline" data-testid="link-back-login">BACK TO SIGN IN →</Link>
          </div>
        </div>
        <form onSubmit={submit} className="md:col-span-7 md:col-start-7 border border-[#DCE3ED] p-8 lg:p-10 bg-white rounded-xl" data-testid="forgot-form">
          <div className="fx-mono-tag mb-6">REQUEST RECOVERY</div>
          {sent ? (
            <p className="text-sm text-[#475569]" data-testid="forgot-sent-msg">
              If an account exists for <strong>{email}</strong>, a recovery email has been sent. Follow the link inside to set a new password.
            </p>
          ) : (
            <>
              <Label className="fx-mono-tag">EMAIL</Label>
              <Input required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 h-11 rounded-md" placeholder="you@company.com" data-testid="forgot-email-input" />
              <Button disabled={loading} className="fx-btn-primary h-11 w-full rounded-lg mt-6 text-sm font-semibold" data-testid="forgot-submit-btn">
                {loading ? "Sending…" : "Send recovery email →"}
              </Button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
